import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { addClass, removeClass } from '@fretadao/f-js-dom';

application.register('occasional-trip-request-change-scheduled-times', class extends Controller {
  static targets = [
    'travelType',
    'ingoingSchedule',
    'outgoingSchedule'
  ];

  connect() {
    if(this.travelTypeTarget) {
      this.#toggleFields(this.travelTypeTarget.value);
    }
  };

  selectScheduledTimes(event) {
    this.#toggleFields(event.target.value);
  }

  #toggleFields(value) {
    switch (value) {
      case 'outgoing':
        this.#makeOutgoingDateFieldsVisible();
        this.#hideIngoingDateFields();
        break;
      case 'round_trip':
        this.#makeIngoingDateFieldsVisible();
        this.#makeOutgoingDateFieldsVisible();
        break;
      case 'ingoing':
      default:
        this.#makeIngoingDateFieldsVisible();
        this.#hideOutgoingDateFields();
        break;
    }
  }

  #makeOutgoingDateFieldsVisible() {
    removeClass(this.outgoingScheduleTarget.closest('.Form-inputGroup'), 'hidden');
    this.outgoingScheduleTarget.setAttribute('required', true);
  }

  #hideOutgoingDateFields() {
    addClass(this.outgoingScheduleTarget.closest('.Form-inputGroup'), 'hidden');
    this.outgoingScheduleTarget.removeAttribute('required');
  }

  #hideIngoingDateFields() {
    addClass(this.ingoingScheduleTarget.closest('.Form-inputGroup'), 'hidden');
    this.ingoingScheduleTarget.removeAttribute('required');
  }

  #makeIngoingDateFieldsVisible() {
    removeClass(this.ingoingScheduleTarget.closest('.Form-inputGroup'), 'hidden');
    this.ingoingScheduleTarget.setAttribute('required', true);
  }
});
